<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-button
              outline
              color="success"
              @click="translateUnfilledFields"
            >一件翻译绿色Field</va-button>
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input
              v-model='insertData.courseId'
              v-show="showUid"
              label='唯一标识'
              disabled
            />
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input
              v-model='insertData.views'
              v-show="showViews"
              label='views'
              disabled
            />
          </div>

          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.name"
              :placeholder="placeholders.name"
              label="公司名称"
              removable
              :messages="message"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.nameEn"
              :placeholder="placeholders.nameEn"
              label="公司名称(英文)"
              removable
              :messages="message"
              :error="!!error.nameEnErrors.length"
              :error-messages="error.nameEnErrors"
              success
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              label="课程标签"
              v-model="insertData.courseTagIds"
              multiple
              :options="computedTags"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              label="导师"
              v-model="insertData.mentorUids"
              multiple
              searchable
              :options="computedMentors"
            />
          </div>
          <div class='flex md12 sm6 xs12' v-show="insertData.imgUrl.length!==0">
            <va-card
              overlay
              :image='insertData.imgUrl'
              class="va-card-image"
            >
            </va-card>
          </div>
          <div class='flex md12 sm6 xs12'>
            <va-card title='公司logo'>
              <va-file-upload
                type='single'
                v-model='insertData.imgUrlArr'
                @input="uploadImage"
              />
            </va-card>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-tree-category isOpen label="你将收获(左边写中文，右边写英文)">
              <va-tree-node
                v-for="reward in insertData.willRewards"
                :key="reward.id"
              >
                <div class="flex row align--center">
                  <va-input v-model="reward.reward" :placeholder="placeholders.willReward" removable class="mb-0 flex md5 sm6 xs12"/>
                  <va-input v-model="reward.rewardEn" :placeholder="placeholders.willRewardEn" removable class="mb-0 flex md5 sm6 xs12" success/>
                  <va-icon
                    name="ion ion-md-close"
                    color="info"
                    class="ml-2 pa-1 shrink" d
                    style="cursor: pointer;"
                    @click.native="removeReward(reward)"
                  />
                </div>
              </va-tree-node>
              <va-tree-node>
                <va-button class="mb-2" @click="addReward()">
                  新增收获
                </va-button>
              </va-tree-node>
            </va-tree-category>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.responsibility"
              :placeholder="placeholders.responsibility"
              type="textarea"
              label="工作职责"
              :autosize="true"
              removable
              :messages="message"
              :error="!!error.responsibilityErrors.length"
              :error-messages="error.responsibilityErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.responsibilityEn"
              :placeholder="placeholders.responsibilityEn"
              type="textarea"
              label="工作职责(英文)"
              :autosize="true"
              removable
              :messages="message"
              :error="!!error.responsibilityEnErrors.length"
              :error-messages="error.responsibilityEnErrors"
              success
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.projectDescription"
              :placeholder="placeholders.projectDescription"
              type="textarea"
              label="项目简介"
              :autosize="true"
              removable
              :messages="message"
              :error="!!error.projectDescriptionErrors.length"
              :error-messages="error.projectDescriptionErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.projectDescriptionEn"
              :placeholder="placeholders.projectDescriptionEn"
              type="textarea"
              label="项目简介(英文)"
              :autosize="true"
              removable
              :messages="message"
              :error="!!error.projectDescriptionEnErrors.length"
              :error-messages="error.projectDescriptionEnErrors"
              success
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-select
              label="状态"
              v-model="insertData.status"
              :options="statusOptions"
              :messages="message"
              :error="!!error.statusErrors.length"
              :error-messages="error.statusErrors"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越大越靠前"
              removable
              type="number"
              :min="1"
              oninput="if(value<1)value=1"
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.createTime"
              label="创建时间"
              disabled
              v-show="insertData.createTime"
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import uploadApi from '../../../api/upload'
import enterpriseToOneApi from '../../../api/enterpriseToOne'
import { copyObject, formatTime, translateData } from '../../../utils/common'
import mentorApi from '../../../api/mentor'
import { SERVICE_STATUS_TYPES, TAG_TYPE } from '../../../utils/constants'
import tagApi from '../../../api/tag'

export default {
  data () {
    return {
      insertData: {
        id: null,
        courseId: '',
        name: '',
        imgUrl: '',
        imgUrlArr: [],
        willRewards: [],
        views: null,
        projectDescription: '',
        responsibility: '',
        status: '草稿中',
        sortNum: 1,
        isOfficial: null,
        createTime: null,
        courseTagIds: [],
        mentorUids: [],
        creatorUid: '',
        nameEn: '',
        projectDescriptionEn: '',
        responsibilityEn: '',
      },
      placeholders: {
        name: '例: Google Software Engineering Assistant',
        projectDescription: '例: 本项目由硅谷谷歌的导师亲自带领，完成工业界的项目课题。时间1--3个月不等，每周会有固定的例会讨论',
        responsibility: '例: 主参与全栈软件系统的开发与升级 学习复杂系统设计与后端开发技术 帮助客户开发与建立网站与软件应用',
        willReward: '例: 名企导师的推荐信, 简历镀金',
        nameEn: '例: Google Software Engineering Assistant',
        projectDescriptionEn: 'Example: This project is personally led by mentors from Google in Silicon Valley to complete project topics in the industry. The time ranges from 1 to 3 months, and there will be regular meetings every week for discussion.',
        responsibilityEn: 'Example: Participate in the development and upgrade of full-stack software systems. Learn complex system design and back-end development technology. Help customers develop and build websites and software applications.',
        willRewardEn: 'Examples: Recommendation letters from famous company mentors, gold-plated resumes',
      },
      message: ['Required field'],
      courseTags: [],
      mentors: [],
      error: {
        nameErrors: [],
        sortNumErrors: [],
        projectDescriptionErrors: [],
        responsibilityErrors: [],
        nameEnErrors: [],
        projectDescriptionEnErrors: [],
        responsibilityEnErrors: [],
        statusErrors: [],
      },
      showId: false,
      showUid: false,
      showViews: false,
      showCreatedAt: false,
      title: '新增名企一对一',
      statusOptions: SERVICE_STATUS_TYPES.map(item => { return item.TEXT }),
      submitButtonStatus: true,
    }
  },
  created () {
    const params = this.$route.params
    if (params.id != null) {
      this.showId = true
      this.showUid = true
      this.showViews = true
      this.showCreatedAt = true
      this.title = '编辑名企一对一'
      // 通过id获取详情
      enterpriseToOneApi.getEnterpriseToOne(params.id).then(response => {
        copyObject(response.enterpriseToOne, this.insertData)
        this.insertData.createTime = formatTime(this.insertData.createTime)
        // eslint-disable-next-line no-prototype-builtins
        if (response.enterpriseToOne.hasOwnProperty('status')) {
          SERVICE_STATUS_TYPES.map((item) => {
            if (response.enterpriseToOne.status === item.CODE) {
              this.insertData.status = item.TEXT
            }
          })
        }
        // eslint-disable-next-line no-prototype-builtins
        if (response.hasOwnProperty('courseTags') && response.courseTags.length !== 0) {
          const that = this
          that.insertData.courseTagIds = []
          response.courseTags.forEach(x => {
            that.insertData.courseTagIds.push(x.name)
          })
        }
        // eslint-disable-next-line no-prototype-builtins
        if (response.enterpriseToOne.hasOwnProperty('willRewards') && response.enterpriseToOne.willRewards.length !== 0) {
          const that = this
          this.insertData.willRewards = []
          response.enterpriseToOne.willRewards.forEach(x => {
            that.insertData.willRewards.push({
              id: Math.floor(Math.random() * 100000),
              reward: x.reward,
              rewardEn: x.rewardEn,
            })
          })
        }
        // eslint-disable-next-line no-prototype-builtins
        if (response.hasOwnProperty('mentors') && response.mentors.length !== 0) {
          const that = this
          that.insertData.mentorUids = []
          response.mentors.forEach(x => {
            that.insertData.mentorUids.push(x.nickname + '(' + x.uid + ')')
          })
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
    this.listCourseTag()
    this.listMentor()
  },
  computed: {
    computedTags () {
      return this.courseTags.map(x => {
        return x.name
      })
    },
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.nameEnErrors.length &&
          !this.error.sortNumErrors.length &&
          !this.error.projectDescriptionErrors.length &&
          !this.error.projectDescriptionEnErrors.length &&
          !this.error.statusErrors.length &&
          !this.error.responsibilityErrors.length &&
          !this.error.responsibilityEnErrors.length
    },
    flipTags () {
      const flipTags = {}
      this.courseTags.forEach(x => {
        flipTags[x.name] = x.id
      })
      return flipTags
    },
    computedMentors () {
      return this.mentors.map(x => {
        return x.nickname + '(' + x.uid + ')'
      })
    },
    flipMentors () {
      const flipMentors = {}
      this.mentors.forEach(x => {
        flipMentors[x.nickname + '(' + x.uid + ')'] = x.uid
      })
      return flipMentors
    },
  },
  methods: {
    listMentor () {
      const params = {
        pageNumber: 1,
        pageSize: 1000,
      }
      mentorApi.listMentor(params).then(response => {
        this.mentors = response.mentors
      }).catch(error => {
        console.log(error)
      })
    },
    listCourseTag () {
      tagApi.listTag({ tagType: TAG_TYPE.COURSE_TAG.CODE }).then(response => {
        this.courseTags = response.tags
      }).catch(error => {
        console.log(error)
      })
    },
    addReward () {
      this.insertData.willRewards.push({
        id: Math.floor(Math.random() * 100000),
        reward: '',
        rewardEn: '',
      })
    },
    removeReward (reward) {
      this.insertData.willRewards = this.insertData.willRewards.filter(x => x !== reward)
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      if (this.insertData.imgUrl.length === 0) {
        this.showToast('有图片未上传，请请检查后重试！', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      this.changeButtonStatus(false)
      const data = {
        name: this.insertData.name,
        nameEn: this.insertData.nameEn,
        courseId: this.insertData.courseId,
        views: this.insertData.views,
        imgUrl: this.insertData.imgUrl,
        creatorUid: this.insertData.creatorUid,
        projectDescription: this.insertData.projectDescription,
        projectDescriptionEn: this.insertData.projectDescriptionEn,
        responsibility: this.insertData.responsibility,
        responsibilityEn: this.insertData.responsibilityEn,
        sortNum: this.insertData.sortNum !== null ? this.insertData.sortNum : 100,
        willRewards: this.insertData.willRewards.map(x => {
          return {
            reward: x.reward,
            rewardEn: x.rewardEn,
          }
        }),
        courseTagIds: this.insertData.courseTagIds.map(tagName => {
          return this.flipTags[tagName]
        }),
        mentorUids: this.insertData.mentorUids.map(nicknameWithUid => {
          return this.flipMentors[nicknameWithUid]
        }),
      }
      if (this.insertData.status !== null) {
        SERVICE_STATUS_TYPES.map((item) => {
          if (this.insertData.status === item.TEXT) {
            data.status = item.CODE
          }
        })
      }
      if (this.insertData.id != null) {
        data.id = this.insertData.id
        enterpriseToOneApi.updateEnterpriseToOne(data.id, data).then(response => {
          if (response.success === true) {
            this.showToast('更新名企一对一成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listEnterpriseToOne' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      } else {
        enterpriseToOneApi.saveEnterpriseToOne(data).then(response => {
          if (response.success === true) {
            this.showToast('添加名企一对一成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listEnterpriseToOne' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.nameEnErrors = this.insertData.nameEn ? [] : ['nameEn is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
      this.error.projectDescriptionErrors = this.insertData.projectDescription ? [] : ['projectDescription is required']
      this.error.projectDescriptionEnErrors = this.insertData.projectDescriptionEn ? [] : ['projectDescriptionEn is required']
      this.error.responsibilityErrors = this.insertData.responsibility ? [] : ['responsibility is required']
      this.error.responsibilityEnErrors = this.insertData.responsibilityEn ? [] : ['responsibilityEn is required']
      this.error.statusErrors = this.insertData.status ? [] : ['status is required']
    },
    uploadImage () {
      if (this.insertData.imgUrlArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'image')
      formData.append('file', this.insertData.imgUrlArr[this.insertData.imgUrlArr.length - 1])
      uploadApi.uploadImage(formData).then(response => {
        this.insertData.imgUrl = response.url
        this.showToast('上传图片成功', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    async  translateWillRewards (rewards) {
      const translationPromises = rewards.map(async (reward, index) => {
        if (reward.reward && !reward.rewardEn) {
          try {
            rewards[index].rewardEn = await translateData(reward.reward)
          } catch (error) {
            console.error(`翻译技能 ${index} 时出现错误:`, error)
          }
        }
      })
      await Promise.all(translationPromises)
    },
    async translateUnfilledFields () {
      // 课程标题
      if (this.insertData.name !== '' && this.insertData.nameEn === '') {
        this.insertData.nameEn = await translateData(this.insertData.name)
      }
      // 课程介绍
      if (this.insertData.projectDescription !== '' && this.insertData.projectDescriptionEn === '') {
        this.insertData.projectDescriptionEn = await translateData(this.insertData.projectDescription)
      }
      // 课程大纲
      if (this.insertData.responsibility !== '' && this.insertData.responsibilityEn === '') {
        this.insertData.responsibilityEn = await translateData(this.insertData.responsibility)
      }
      // 你将收获
      await this.translateWillRewards(this.insertData.willRewards)
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
